import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@Component({
  selector: 'ideal-legacy-loading-screen',
  standalone: true,
  imports: [MatCardModule, MatProgressBarModule],
  templateUrl: './legacy-loading-screen.component.html',
  styleUrl: './legacy-loading-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegacyLoadingScreenComponent {}
